import * as React from 'react';
import { FC } from 'react';
import { Show, TabbedShowLayout, Tab } from 'react-admin';

import { Typography } from '@material-ui/core';
import { Course, FieldProps } from '../types';
import CourseDetailsSection from './tabs/CourseDetailsSection';
import CourseHistory from './tabs/CourseHistory';

const Title: FC<FieldProps<Course>> = ({ record }) =>
    record ? <Typography>Réservation</Typography> : null;

/**
 * Show Component
 */
const CourseShow = (props: any) => {
    return (
        <Show {...props} component="div" tltle={<Title />}>
            <TabbedShowLayout>
                <Tab label="resources.courses.tabs.details">
                    <CourseDetailsSection {...props} />
                </Tab>
                <Tab label="resources.courses.tabs.history">
                    <CourseHistory />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

export default CourseShow;
